import { Title } from "@angular/platform-browser";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { addSegmentToList, initializeUserSegmentArray } from "@ponder-features/header/navbar/navbar.component";
import { UserStatCategoryButtonComponent } from "./user-stat-category-button.component";
import { UserStatsCategory } from "./user-stats-category";
import { Subscription, take } from "rxjs";
import { UserCollectionGeneralStatsComponent } from "./collection-general/user-collection-general-stats.component";
import { UserCollectionMagicStatsComponent } from "./collection-magic/user-collection-magic-stats.component";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { GetUserResourceVisibilityResponse, UserProtectedResource } from "@apiserver-rest/ponder-data-client-base";
import { AfterViewInit, Component, Input } from "@angular/core";

@Component({
    imports: [
        UserStatCategoryButtonComponent,
        UserCollectionGeneralStatsComponent,
        UserCollectionMagicStatsComponent,
        LoadingComponent
    ],
    templateUrl: "./user-stats.component.html"
})
export class UserStatsComponent implements AfterViewInit {
    @Input() public username!: string;

    public isOwnStats: boolean = false;
    public isVisible?: boolean = undefined;
    public statsCategories = UserStatsCategory;
    public selectedCategory: UserStatsCategory = UserStatsCategory.CollectionGeneral;

    private categorySelectedSub!: Subscription;

    public constructor(
        private ponderDataClient: PonderDataClient,
        private authService : AuthService,
        private pageTitle: Title,
        private events: EventBroker) {
            this.events.ui.navbarUpdateEvent.emit();
            this.categorySelectedSub = this.events.stats.categorySelected.subscribe({
                next: (category: UserStatsCategory) => {
                    this.onCategorySelected(category);
                }
            });
    }

    public ngOnDestroy(): void {
        this.categorySelectedSub.unsubscribe();
    }

    public ngAfterViewInit() {

    }
    
    public ngOnInit(): void {
        this.pageTitle.setTitle(`Ponder > ${this.username} > Stats`);
        this.sendNavbarUpdate();
        
        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession?.username && (authSession.username == this.username)) {
                this.isOwnStats = true;
                this.isVisible = true;
            }
            else {
                this.ponderDataClient
                .userResourceVisibility(this.username, UserProtectedResource.Stats)
                .pipe(take(1))
                .subscribe({
                    next: (response: GetUserResourceVisibilityResponse) => {
                        if (response.success && response.isVisible) {
                            this.isVisible = true;
                        }
                    }
                })
                .add(() => { 
                    if (this.isVisible == undefined) {
                        this.isVisible = false;
                    }
                });
            }
        });
    }
    
    private sendNavbarUpdate(): void {
        var segments = initializeUserSegmentArray(this.username!);
        addSegmentToList(segments, "Stats", "Stats");
        
        this.events.ui.navbarUpdateEvent.emit(segments);
    }

    private onCategorySelected(category: UserStatsCategory): void {
        this.selectedCategory = category;
    }
}